// PAY ATTENTION: name angular wrapper as [COMPONENT_NAME].angular.ts
const dependencies = importAngularDependencies(
  require.context(
    './',
    true,
    /^(?!.*\.(spec|test)\.(angular.ts)$).*\.(angular.ts)$/
  ),
  './call-mobile.js'
);

export default angular.module('doxy.call-mobile', dependencies).name;
